import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('contactUs')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('contactSubtitle')}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {/* Contact Info */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Address */}
            <div className="flex flex-col items-center text-center gap-4 group p-6 bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-blue-600 transition-colors duration-300">
                <MapPin className="text-blue-600 group-hover:text-white transition-colors duration-300" size={28} />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{t('address')}</h3>
                <p className="text-gray-600">
                  225, Avenue Du Progrès<br />
                  Bon Marché, Barumbu<br />
                  Kinshasa, RD Congo
                </p>
              </div>
            </div>

            {/* Phone */}
            <div className="flex flex-col items-center text-center gap-4 group p-6 bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-blue-600 transition-colors duration-300">
                <Phone className="text-blue-600 group-hover:text-white transition-colors duration-300" size={28} />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{t('telephone')}</h3>
                <a href="tel:+243823060716" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
                  +243 823 060 716
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="flex flex-col items-center text-center gap-4 group p-6 bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-blue-600 transition-colors duration-300">
                <Mail className="text-blue-600 group-hover:text-white transition-colors duration-300" size={28} />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Email</h3>
                <a href="mailto:contact@izitravels.net" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 break-all">
                  contact@izitravels.net
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
